import styled, { css } from 'styled-components';

export const HeadingSmall = styled.h3`
	${({ theme }) => css`
		${{ ...theme.fonts.heading.sm }}
	`}
`;
